import {
    takeEvery,
    call,
    all,
    put,
    fork,
} from 'redux-saga/effects';

import { types, actions } from './reducer';
import BaseUnitService from '@iso/services/SettingsService/ProductService/BaseUnitService';
import { extractError } from '@iso/lib/helpers/api';

function* submitBaseUnit({ id, data }) {
    try {
        let response;
        if(id) {
            response = yield call(BaseUnitService.editBaseUnit, id, data);
        } else {
            response = yield call(BaseUnitService.addBaseUnit, data);
        }
        yield put(actions.submitBaseUnitSucceeded(response.data));
    } catch (error) {
        yield put(actions.submitBaseUnitFailed(extractError(error)));
    }
}

function* watchSubmitBaseUnit() {
    yield takeEvery(
        types.REQUEST_SUBMIT_BASE_UNIT,
        submitBaseUnit,
    );
}

function* createSaga() {
    yield all([
        fork(watchSubmitBaseUnit),
    ]);
}

export default createSaga;